import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-request-password-reset',
  templateUrl: './request-password-reset.component.html',
})
export class RequestPasswordResetComponent implements OnInit, OnDestroy {
  /**
   * @description
   * Request password reset by entering email.
   */

  form: FormGroup;
  subscriptions: Subscription[] = [];
  toastMessage;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [''],
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  onSubmit() {
    const formData = this.form.getRawValue();

    this.subscriptions.push(
      this.authService.getResetPasswordEmail(formData).subscribe({
        next: (res: any) => {
          this.toastMessage = [
            {
              severity: 'success',
              summary: '',
              detail: res.message,
            },
          ];
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (error: any) => {
          console.log('ERROR', error);
          this.toastMessage = [
            {
              severity: 'error',
              summary: '',
              detail: error.error.message,
            },
          ];
        },
      })
    );
  }
}
